import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0bf14f1c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.scss?vue&type=style&index=0&id=0bf14f1c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf14f1c",
  null
  
)

export default component.exports